import { createStore } from 'redux';
import { persistCombineReducers, persistStore } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import configureUser from '../reducers/user';
import configureDevice from '../reducers/device';

const config = {
  key: 'root',
  storage,
};

const reducer = persistCombineReducers(config, {
  user: configureUser,
  device: configureDevice,
});

export default function configureStore () {
  let store = createStore(reducer);
  let persistor = persistStore(store);

  return {persistor, store};
}



// WEBPACK FOOTER //
// ./src/store/index.js